import * as React from 'react'

/**
 * "Background" icon used in the Batch / add-menu rail button.
 * Matches Figma node 10852-4086 / "Icon /Background" (diagonal-stripe pattern
 * inside a rounded rectangle). Different from Icons.Background (the "A" icon).
 */
function AddMenuBackgroundIcon({ size = 24, color = '#111111' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Original Figma viewBox is 20×20, centred in 24×24 with a 2px inset */}
      <g transform="translate(2, 2)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3C0 1.34315 1.34315 0 3 0H17C18.6569 0 20 1.34315 20 3V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V3ZM16.5858 2H13.7566L2 13.7566V16.5858L16.5858 2ZM8.09433 2H10.9282L2 10.9282V8.09433L8.09433 2ZM5.2659 2H3C2.44771 2 2 2.44772 2 3V5.2659L5.2659 2ZM3.41421 18H6.25656L18 6.25656V3.41421L3.41421 18ZM11.9304 18H9.08499L18 9.08499V11.9304L11.9304 18ZM14.7588 18H17C17.5523 18 18 17.5523 18 17V14.7588L14.7588 18Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default AddMenuBackgroundIcon
